import React from "react";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Table from "components/Table/Table.jsx";
import AddCircle from "@material-ui/icons/AddCircle";
import Close from "@material-ui/icons/Close";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SymbolsModal from '../Wizard/SymbolsModal'

import styles from "assets/jss/material-dashboard-pro-react/views/form";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import _ from 'lodash'
import {subProfileSave, subProfileFetch} from 'actions/subProfiles'
import {
  subProfileRulesSave,
  subProfileRulesFetchHelper,
	subProfileRuleFetch,
	subProfileRuleRemove
} from 'actions/subProfileRules'
import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'

import {
  symbolGroupsFetch,
  symbolGroupFilter
} from 'actions/symbolGroups'
import {
  danger,
  success,
} from 'actions/notification'

const customStyle = {
  selectFormControlBorder: {
    "& > div": {
      "&:before": {
        borderBottomWidth: "1px !important",
        borderBottomColor: "silver !important"
      },
    }
  },
  selectCustom: {
    fontSize: '14px',
  },
  paddingZero: {
    padding: '0 !important'
  },
  ratioGroupItem:{
    height: '28px',
  },
  ratioInput:{
    padding: '3px',
    width: '100%',
    marginRight: '3px',
    maxWidth: '120px',
  },
  textColumns:{
    paddingTop: '30px',
    display: 'block',
    width: '100%',
    height: '100%',
  },
  radio: {
    '&$checked': {
      color: '#00acc1',
    },
  },
  checked: {}
}

class Cryptos extends React.Component {
  button = React.createRef()
	state = {
    symbolType: 'CRYPTO',
		form: {
      id: 0,
      spread: null,
      spreadValueType: null,
      markup: null,
      markupValueType: null,
      //percentage: '',
      commission: null,
      commissionValueType: null,
    },
    subProfileRulesState: [],
    symbolTree: [],
    typeSymbols: [],
    selectedSubProfileRule: {},
    openModal: false,
    showTable: false,
    goToNext: true,
    showCommonSetings: false,
  }

  componentDidUpdate(prevProps, prevState){
    if (prevProps.additionalWizardData !== this.props.additionalWizardData) {
      this.setData()
    }
    if (prevProps.changeStep !== this.props.changeStep) {
      // handle submit action
      if(this.props.stepDataObject.stepId === this.props.changeStep.currentStep.stepId){
        this.button.current.click()
        this.props.navigationStepChange(this.props.changeStep.nextStep.key)
        this.setState({...this.state, goToNext: false})
      }
    }
  }
  createRuleSymbols(){
    const {allSymbols, subProfileRules} = this.props.additionalWizardData
    let dbrules = [...subProfileRules]
    const newRules = dbrules.map((r) => {
      let newRule = {...r}
      let newSymbols = []
      r.symbols.forEach((s)=>{
        let symbObj = allSymbols.find((x) => x.symbolId === s)
        if (symbObj) newSymbols.push(symbObj)
      })
      newRule.symbols = newSymbols
      return newRule
    })
    return newRules
  }
  setData(){
    const {allSymbols, subProfile, absoluteRebateValues} = this.props.additionalWizardData
    const {symbolType} = this.state
    
    const newRules = this.createRuleSymbols()

    let typeSymbols = allSymbols.filter((x) => x.type === symbolType)
    //rebate values of symbol
    let typeRebateValues = typeSymbols.map((s)=> {
      let rebateValues = absoluteRebateValues.find((ar)=> ar.symbolId === s.symbolId)
      return {...rebateValues, symbolName: s.name}
    })
    // console.log(typeRebateValues)

    let groups= [...new Set(typeSymbols.filter((s) => s.groupId).map((s) => s.groupId))] // symbol groups with whatever is inside
    let symbolGroups = []

    groups.forEach((group)=> {
      let baseSymbols = typeSymbols.filter((s) => s.groupId === group && !s.parentSymbolId)
      let symbolsWithParent = typeSymbols.filter((s) => s.parentSymbolId)
      baseSymbols.forEach((base) => {
        let children = symbolsWithParent.filter((s) => s.parentSymbolId === base.symbolId)
        base.children = children
      })
      symbolGroups.push({groupedBy: group, baseSymbols: baseSymbols})
    })
    
    let symbolsWithoutGroup= typeSymbols.filter((s) => !s.parentSymbolId && !s.groupId)
    symbolsWithoutGroup.forEach((parent) => {
      let children = typeSymbols.filter((s) => s.parentSymbolId === parent.symbolId && !s.groupId && !parent.groupId)
      if(children){
        parent.children = children
      }
    })
    
    if(subProfile){
      const typeRule = newRules.find((x) => x.symbolTypes.includes(symbolType))
      let filterSubProfileRules = newRules.filter((x) => x.symbols && x.symbols.find((s) => s.type === symbolType))
      let typeSubProfileRule = this.filterDeletedRules(filterSubProfileRules)
      let showTable = typeSubProfileRule.length !== 0
      if(newRules.lenght === 0 || !typeRule){
        this.setState({
          ...this.state,
          form:{
            id: 0,
            spreadValueType: subProfile.spreadValueType,
            spread: subProfile.spread,
            markupValueType: subProfile.markupValueType,
            markup: subProfile.markup,
            commissionValueType: subProfile.commissionValueType,
            commission: subProfile.commission,
          },
          subProfileRulesState: typeSubProfileRule,
          symbolTree: [...symbolGroups, ...symbolsWithoutGroup],
          typeSymbols,
          showTable,
          typeRule,
          typeRebateValues,
          showCommonSetings: this.commonSettingHasValues(subProfile)
        })
      } else{
        this.setState({
          ...this.state,
          form:{
            id: typeRule.subProfileRuleId,
            spreadValueType: typeRule.spreadValueType,
            spread: typeRule.spread,
            markupValueType: typeRule.markupValueType,
            markup: typeRule.markup,
            commissionValueType: typeRule.commissionValueType,
            commission: typeRule.commission,
          },
          subProfileRulesState: typeSubProfileRule,
          symbolTree: [...symbolGroups, ...symbolsWithoutGroup],
          typeSymbols,
          showTable,
          typeRule,
          typeRebateValues,
          showCommonSetings: this.commonSettingHasValues(typeRule)
        })
      }
    } else {
      this.setState({
        ...this.state,
        symbolTree: [...symbolGroups, ...symbolsWithoutGroup],
        typeSymbols
      })
    }
  }
	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: '')}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
  }
  radioGroupChange(e, key){
    let {form} = this.state
    form[key] = e.target.value
    this.setState({
      ...this.state,
      form: form
    })
  }
  renderAbsoluteValues(prop){
    const {typeRebateValues} = this.state
    let absProperty = ''
    switch (prop) {
      case 'spread':
        absProperty='spreadAbsolute'
        break
      case 'percentage':
        absProperty='percentageAbsolute'
        break
      case 'commission':
        absProperty='commissionAbsolute'
        break
      default:
        absProperty = 'markupAbsolute'
        break
    }

    return(
      <div style={{maxWidth: '200px', display: 'flex', flexDirection: 'column'}}>
        <div key={-1} style={{display: 'block', width: '100%', padding: '5px 15px'}}>
          <div style={{fontWeight: 'bolder'}}>Parent Value</div>
        </div>
        {typeRebateValues.map((val, i) => {
          return(
            <div key={i} style={{display: 'flex', width: '100%', padding: '5px 15px'}}>
              <div style={{fontWeight: 'bolder', width: '110px'}}>{val.symbolName}</div>
              <div style={{fontStyle: 'italic'}}>{val[absProperty]}</div>
            </div>
          )
        })}
      </div>
    )
  }
  getRadioButton(data){
    const {classes} = this.props
    return(
      <RadioGroup
        className={'radio-group'}
        name={data.key}
        value={this.state.form[data.key]}
        onChange={(e) => this.radioGroupChange(e, data.key)}
      >
        <FormControlLabel className={classes.ratioGroupItem} value="RATIO" control={<Radio classes={{root: classes.radio, checked: classes.checked}} />} label="% of parent" />
        {this.state.form[data.key] === 'RATIO' && (
          <div style={{position: 'relative'}}>
            <div style={{display: 'flex', position: 'relative'}}>
              <input
              type='number'
              step="any"
              className={classes.ratioInput}
              value={this.state.form[data.inputKey] || this.state.form[data.inputKey] === 0 ? this.state.form[data.inputKey] : ''}
              onChange={(e)=> this.change(e, data.inputKey)}
              placeholder='%' />
              <div className={'subprofile-info-btn'}>
                <span>i</span>
              </div>
              <div className={'subprofile-info-popup'}>
                {this.renderAbsoluteValues(data.inputKey)}
              </div>
            </div>
            
          </div>
        )}
        <FormControlLabel className={classes.ratioGroupItem} value="ABSOLUTE" control={<Radio classes={{root: classes.radio, checked: classes.checked}} />} label={data.dontShowPlaceholderPips ? 'value' : 'value in pips' } />
        {this.state.form[data.key] === 'ABSOLUTE' && (
          <div style={{position: 'relative'}}>
            <div style={{display: 'flex', position: 'relative'}}>
              <input
              type='number'
              step="any"
              className={classes.ratioInput}
              value={this.state.form[data.inputKey] || this.state.form[data.inputKey] === 0 ? this.state.form[data.inputKey] : ''}
              onChange={(e)=> this.change(e, data.inputKey)}
              placeholder={data.dontShowPlaceholderPips ? '' : 'Pips'} />
              <div className={'subprofile-info-btn'}>
                <span>i</span>
              </div>
              <div className={'subprofile-info-popup'}>
                {this.renderAbsoluteValues(data.inputKey)}
              </div>
            </div>
          </div>
        )}
      </RadioGroup>
    )
  }
  commonSettingHasValues(data){
    return (data.spread !== null && data.spread !== '')
      || (data.markup !== null && data.markup !== '')
      || (data.commission !== null && data.commission !== '')
  }
  submit(e){
    e.preventDefault()
    const {symbolType} = this.state
    const match = this.props.match
    let data = {...this.state.form}

    data.subProfileRuleId = data.subProfileRuleId || data.id
    data.symbolTypes = [symbolType]
    if(data.spread === null || data.spread === ''){
      data.spreadValueType = null
      data.spread = null
    }
    if(data.markup === null || data.markup === ''){
      data.markupValueType = null
      data.markup = null
    }
    if(data.commission === null || data.commission === ''){
      data.commissionValueType = null
      data.commission = null
    }
    this.props.subProfileRulesSave(match.params.id, data)
      .then(e => {
        this.setState({...this.state, form:{...this.state.form, ...e}, typeRule:{...e}})
        if(this.state.goToNext) {
          this.props.goToNextStep()
        }
      })
      .catch((e)=>{
        if(data.subProfileRuleId){
          this.props.subProfileRuleFetch(match.params.id, data.subProfileRuleId).then((res) =>{
            delete res.symbols
            this.setState({...this.state, typeRule:{...res}, form:{...res, id: res.subProfileRuleId}})
          })
        }
        this.props.danger(e+'', 120, 'bm')
      })
  }
  addNewRule(){
    if(this.state.newSubProfileRule) return
    this.setState({
      ...this.state,
      newSubProfileRule:{
        //spreadValueType: '',
        spread: null,
        //markupValueType: '',
        markup: null,
        //commissionValueType: '',
        commission: null,
        symbols: [],
        symbolGroups: [],
        symbolTypes: []
      }
    })
  }
  renderTableInput(e, property, placeholder, width){
    return(
      <Input
        value={e[property]}
        placeholder={placeholder}
        style={{maxWidth: width || '130px'}}
        onChange={(s) => this.changeRule(s, e.subProfileRuleId, property)}
      />
    )
  }
  renderTableRadio(e, property, inputProp){
    const {classes} = this.props
    return(
      <RadioGroup
        className={'radio-group'}
        value={e[property]}
        onChange={(s) => this.changeRule(s, e.subProfileRuleId, property)}
      >
        <FormControlLabel className={classes.ratioGroupItem} value="RATIO" control={<Radio classes={{root: classes.radio, checked: classes.checked}} />} label="% of parent" />
        {e[property] === 'RATIO' && (
          <input
            type='number'
            className={classes.ratioInput}
            value={e[inputProp] || e[inputProp] === 0 ? e[inputProp] : ''}
            onChange={(s) => this.changeRule(s, e.subProfileRuleId, inputProp)}
            placeholder='%' />
        )}
        <FormControlLabel className={classes.ratioGroupItem} value="ABSOLUTE" control={<Radio classes={{root: classes.radio, checked: classes.checked}} />} label={inputProp === 'commission' ? 'value' : 'value in pips'} />
        {e[property] === 'ABSOLUTE' && (
          <input
            type='number'
            className={classes.ratioInput}
            value={e[inputProp] || e[inputProp] === 0 ? e[inputProp] : ''}
            onChange={(s) => this.changeRule(s, e.subProfileRuleId, inputProp)}
            placeholder={inputProp === 'commission' ? '' : 'Pips'} />
        )}
      </RadioGroup>
    )
  }
  renderTableSelect(e, property, placeholder, options){
    const {classes} = this.props
    return(
      <Select
        required={false}
        native
        value={e[property] || '' }
        style={{width: '100px'}}
        MenuProps={{ className: classes.selectMenu }}
        classes={{ select: classes.select + ' ' + classes.selectCustom }}            
        inputProps={{
          onChange: event => this.changeRule(event, e.subProfileRuleId, property),
          //id: property
        }}
      >
        <option value="" disabled>{placeholder}</option>
        {Object.values(options).map((item, ind) => 
          <option key={ind} value={item.value}>{item.label}</option>
        )}
      </Select>
    )
  }
  findSymbolsColumnName(e){
    e.symbols = e.symbols.length !== 0
      ? _(e.symbols).filter((s) => s.type === this.state.symbolType).orderBy(['name'], ['asc']).value()
      : e.symbols
    let columnTxt = (e.symbols.length !== 0 && e.symbols[0].name) || (e.symbolGroups.length !== 0 && e.symbols[0].name)
      ? `${e.symbols[0].name.substr(0, 6)}` : ''
    return columnTxt
  }
  renderTableSymbols(e){
    let hasValues = e.symbolGroups.length !== 0 || e.symbols.length !== 0 ? true : false
    e.symbols = e.symbols.length !== 0
      ? _(e.symbols).filter((s) => s.type === this.state.symbolType).orderBy(['name'], ['asc']).value()
      : e.symbols
    let symbolSet = (e.symbols.length !== 0 && e.symbols[0].name) || (e.symbolGroups.length !== 0 && e.symbols[0].name)
      ? `${e.symbols[0].name.substr(0, 6)}...,` : ''
    return (
      <div
        style={{
          borderBottom: '1px solid gray',
          minHeight: '5px',
          width: '110px',
          display:'flex',
          cursor: 'pointer',
          padding: '6px 0 1px'
        }}
        onClick={() => this.setState({...this.state, openModal: true, selectedSubProfileRule: e})}
      >
        <div style={{width: '100%'}}>{hasValues? symbolSet : 'Select...'}</div>
        <ArrowDropDown style={{float: 'right', color: 'gray'}} />
      </div>
    )
  }
  changeNewRule(e, property){
    let {newSubProfileRule} = this.state
    newSubProfileRule[property] = e.target.value
    this.setState({...this.state, newSubProfileRule})
  }
  changeRule(e, id, property){
    if(!id) return this.changeNewRule(e, property)
    let {subProfileRulesState} = this.state
    subProfileRulesState.find((x) => x.subProfileRuleId === id)[property] = e.target.value
    this.setState({
      ...this.state,
      subProfileRulesState: subProfileRulesState
    })
  }
  setSymbols(subProfileRuleId, data){
    const {subProfileRulesState, typeSymbols} = this.state
    if(subProfileRuleId){
      subProfileRulesState.forEach((item) => {
        if(item.subProfileRuleId === subProfileRuleId){
          item.symbolGroups = data.symbolGroups
          item.symbols = []
          data.symbols.forEach((symb) => {
            item.symbols.push(typeSymbols.find((z) => z.symbolId === symb))
          })
        }
      })
      this.setState({...this.state, subProfileRulesState})
    } else{
      let {newSubProfileRule} = this.state
      newSubProfileRule.symbolGroups = data.symbolGroups
      newSubProfileRule.symbols = []
      data.symbols.forEach((symb) => {
        newSubProfileRule.symbols.push(typeSymbols.find((z) => z.symbolId === symb))
      })
      this.setState({...this.state, newSubProfileRule})
    }
    
  }
  saveTableItem(i){
    const match = this.props.match
    let data = {...i}
    let isNew = !data.subProfileRuleId

    //if special case has symbols from other symbol types
    let otherTypeSymbol = data.symbols.find((x) => x.type !== this.state.symbolType)
    if(otherTypeSymbol) {
      //remove the symbols of this tab symbol type specialcase
      let oldRule = {...data}
      oldRule.symbols = i.symbols.filter((x)=> x.type !== this.state.symbolType)
      oldRule.symbols = oldRule.symbols.map((s) => s.symbolId)
      this.props.subProfileRulesSave(match.params.id, oldRule)
      .then(() => {
        // create new special case with the symbols of this tab symbol type
        let newRule = {...data}
        newRule.symbols = i.symbols.filter((x)=> x.type === this.state.symbolType)
        newRule.symbols = newRule.symbols.map((s) => s.symbolId)
        delete newRule.subProfileRuleId
        this.props.subProfileRulesSave(match.params.id, newRule).then(() => {
          this.props.success('Custom Setting updated ',4)
          this.fetchData()
        }).catch(e=>{this.props.danger(e+'',4);})
      })
      .catch(e=>{this.props.danger(e+'',4);})
    } else {
      data.symbols = data.symbols.map((s) => s.symbolId)
      if(data.spread === null || data.spread === ''){
        data.spreadValueType = null
        data.spread = null
      }
      if(data.markup === null || data.markup === ''){
        data.markupValueType = null
        data.markup = null
      }
      if(data.commission === null || data.commission === ''){
        data.commissionValueType = null
        data.commission = null
      }
      this.props.subProfileRulesSave(match.params.id, data)
      .then(e => {
        //update symbol tree state
        this.props.success(isNew? 'Custom Setting added':'Custom Setting updated ',4)
        this.fetchData()
        if(isNew){
          this.setState({...this.state, newSubProfileRule: null})
        }
      })
      .catch(e=>this.props.danger(e+'', 120, 'bm'))
    }
  }
  fetchData(){
    const {allSymbols} = this.props.additionalWizardData
    
    this.props.subProfileRulesFetch(this.props.match.params.id).then((data) => {
      const newRules = data.map((r) => {
        let newRule = {...r}
        let newSymbols = []
        r.symbols.forEach((s)=>{
          let symbObj = allSymbols.find((x) => x.symbolId === s)
          if (symbObj) newSymbols.push(symbObj)
        })
        newRule.symbols = newSymbols
        return newRule
      })
      let filterRules = newRules.filter((x) => x.symbols && x.symbols.find((s) => s.type === this.state.symbolType))
      let typeRules = this.filterDeletedRules(filterRules)
      this.setState({...this.state, subProfileRulesState: typeRules})
    })
  }
  deleteTableItem(i){
    let isNew = !i.subProfileRuleId
    if(isNew){
      this.setState({...this.state, newSubProfileRule: null})
      return
    }
    const match = this.props.match
    //if this special case has symbols from other types remove only the spacialCase symbols of this tab
    let otherTypeSymbol = i.symbols.find((x) => x.type !== this.state.symbolType)
    if(otherTypeSymbol){
      let newData = {...i}
      newData.symbols = i.symbols.filter(x => x.type !== this.state.symbolType)
      newData.symbols = newData.symbols.map((x) => x.symbolId)
      this.props.subProfileRulesSave(match.params.id, newData).then(() => {
        this.props.success('Custom Setting removed ',4)
        this.fetchData()
      }).catch(e=>{this.props.danger(e+'',4);})
    } else{
      this.props.subProfileRuleRemove(match.params.id, i.subProfileRuleId)
      .then(e => {
        this.props.success('Custom Setting removed ',4)
        this.fetchData()
      })
      .catch(e=>{this.props.danger(e+'',4);})
    }
  }
  filterDeletedRules(data){
    const {allSymbols} = this.props.additionalWizardData
    const {symbolType} = this.state
    //remove if symbols inside special case don't exists in symbols
    let newData = []  
    data.forEach((rule) => {
      let typeSymbols = rule.symbols.filter((c) => c.type === symbolType)
      
      let validSymbols = false
      typeSymbols.forEach((s)=>{
        if(validSymbols) return
        if(allSymbols.find((a) => a.symbolId === s.symbolId)){
          validSymbols = true
        }
      })
      
      if(validSymbols) {
        newData.push({...rule})
      }
    })
    return newData
  }
  commonSettingsCheck(event, check){

    if(!check && this.commonSettingHasValues(this.state.form) && (this.state.form.subProfileRuleId || this.state.form.id) && (this.state.form.subProfileRuleId !== 0 || this.state.form.id !== 0)){
      // set common setings values to null
      let data = {
        ...this.state.typeRule,
        spread: null,
        spreadValueType: null,
        markup: null,
        markupValueType: null,
        commission: null,
        commissionValueType: null,
      }
      this.props.subProfileRulesSave(this.props.match.params.id, data)
        .then((e)=> {
          this.setState({
            ...this.state,
            showCommonSetings: check,
            typeRule: e,
            form:{
              id: 0,
              ...e
            }
          })
          this.props.success('Common setting cleared', 4)
        })
    } else{
      this.setState({...this.state, showCommonSetings: check })
    }
  }
  render() {
    const {classes, currencies} = this.props
    let {subProfileRulesState, symbolType} = this.state
    let {specialCases, profile} = this.props.additionalWizardData
    subProfileRulesState = _(subProfileRulesState).orderBy((d)=> this.findSymbolsColumnName(d), 'asc').value()
    let subProfileRules = []
    if(this.state.newSubProfileRule){
      subProfileRules = [this.state.newSubProfileRule, ...subProfileRulesState]
    } else{
      subProfileRules = subProfileRulesState
    }
    let commonSettings = profile
    const parentProfileType = specialCases.find((x) => x.symbolTypes.includes(symbolType))
    if(parentProfileType){
      commonSettings = parentProfileType
    }
    const commonCurrency = currencies.find((x)=> x.currencyId === commonSettings.commissionCurrencyId)
    const commonCommissionType = commonSettings.commissionType
  	return (
			<form onSubmit={(e) => this.submit(e)}>
				<GridContainer justify="center">
					
        <GridItem xs={12} sm={11} md={11} style={{borderBottom: '1px solid #eee', marginBottom: '40px'}}>
            <div
              onClick={() => this.setState({...this.state, showCommonSetings: !this.state.showCommonSetings})}
              style={{
                display:'flex',
                alignItems: 'center',
                cursor:'pointer',
                maxWidth: '305px'
              }}
            >
              <div style={{paddingRight: '10px'}}>
                <ArrowDropDown />
              </div>
              <div style={{paddingRight: '10px'}}>
                <span>All Crypto Symbols (Optional)</span>
              </div>
              <div style={{paddingRight: '3px'}}>
                <Checkbox
                  tabIndex={-1}
                  disabled={!this.commonSettingHasValues(this.state.form)}
                  onChange={(event, val) => this.commonSettingsCheck(event, val)}
                  checked={this.commonSettingHasValues(this.state.form)}
                  checkedIcon={
                    <Check className={classes.checkedIcon} />
                  }
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked
                  }}
                />
              </div>
            </div>
          </GridItem>

        {this.state.showCommonSetings && (

            <GridContainer justify="center">
              <GridItem xs={5} sm={5} md={3}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <div style={{borderBottom: '1px solid #eee'}}>
                    <span>Spread Rebate</span>
                  </div>
                  <div style={{display:'inline', paddingTop: '5px'}}>
                    {this.getRadioButton({key:'spreadValueType', inputKey:'spread'})} 
                  </div>
                </div>
              </GridItem>

              <GridItem xs={6} sm={6} md={3}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <div style={{borderBottom: '1px solid #eee'}}>
                    <span>Markup Rebate</span>
                  </div>
                  <div style={{display:'inline', paddingTop: '5px'}}>
                    {this.getRadioButton({key:'markupValueType', inputKey:'markup'})} 
                  </div>
                </div>
              </GridItem>

              {/* <GridItem xs={3} sm={3} md={2}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <div style={{borderBottom: '1px solid #eee'}}>
                    <span>Rebate on Shares</span>
                  </div>
                  {this.getInput({
                      key:'percentage',
                      name:'%',
                      icon:'',
                      type:'text',
                      required:false
                  })}  
                </div>
              </GridItem> */}

              <GridItem xs={11} sm={11} md={5}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <div style={{borderBottom: '1px solid #eee'}}>
                    <span>Commission Rebate</span>
                  </div>
                  <GridContainer justify="center">
                    <GridItem xs={6}>
                      <div style={{display:'inline-block', paddingTop: '5px'}}>
                        {this.getRadioButton({key:'commissionValueType', inputKey:'commission', dontShowPlaceholderPips: true})} 
                      </div>
                    </GridItem>
                      
                    <GridItem xs={3}>
                      <div className={classes.textColumns}>
                        <span>{commonCurrency ? commonCurrency.name : ''}</span>
                      </div>
                    </GridItem>

                    <GridItem xs={3}>
                      <div className={classes.textColumns}>
                        <span>{commonCommissionType || ''}</span>
                      </div>
                    </GridItem>

                  </GridContainer>  
                </div>
              </GridItem>
              
            </GridContainer>
        
        )}
          
          <GridItem xs={12} sm={11} md={11} style={{borderBottom: '1px solid #eee'}}>
            <div
              onClick={() => this.setState({...this.state, showTable: !this.state.showTable})}
              style={{
                display:'flex',
                alignItems: 'center',
                paddingTop: '30px',
                cursor:'pointer',
                maxWidth: '265px'
              }}
            >
              <div style={{paddingRight: '10px'}}>
                <ArrowDropDown />
              </div>
              <div style={{paddingRight: '10px'}}>
                <span>Custom Settings (Optional)</span>
              </div>
              <div style={{paddingRight: '3px'}}>
                <Checkbox
                  tabIndex={-1}
                  disabled={true}
                  checked={this.state.subProfileRulesState.length !== 0}
                  checkedIcon={
                    <Check className={classes.checkedIcon} />
                  }
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked
                  }}
                />
              </div>
            </div>
          </GridItem>

          {this.state.showTable && 
          <GridItem xs={12} sm={11} md={11} style={{marginTop: '30px'}}>
            <div style={{float: 'right'}}>
              <span
                onClick={() => this.addNewRule()}
              >
                <AddCircle
                  style={{
                    color: '#00acc1',
                    cursor: 'pointer'
                  }}
                />
              </span>
            </div>
            
          </GridItem>
          }
          {this.state.showTable && 
          <GridItem xs={12} sm={11} md={11} className={classes.paddingZero}>
          
            <div style={{border:'1px solid #AAAAAA', marginTop: '20px'}}>
              <Table
                tableHeaderColor="primary"
                //striped
                responsiveY
                firstChildFullWidth
                tableHead={{
                  symbols: 'Symbol Set',
                  spread: {name: 'Spread Rebate', width: '60px'},
                  markup:"Markup", 
                  //percentage: {name: 'Rebate on Shares', width: '80px'},
                  commission: {name: 'Commission Rebate', width: '98px'},
                  commissionCurrencyId:"",
                  commissionType:"",
                  actions: ''
                }}
                tableData={subProfileRules.map((e,i) => {
                  //let currency = currencies.find((x) => x.currencyId === e.commissionCurrencyId)
                  return [
                    this.renderTableSymbols(e),
                    this.renderTableRadio(e, 'spreadValueType', 'spread'),
                    this.renderTableRadio(e, 'markupValueType', 'markup'),
                    //this.renderTableInput(e, 'percentage', '%'),
                    this.renderTableRadio(e, 'commissionValueType', 'commission'),
                    commonCurrency ? commonCurrency.name : '',
                    commonCommissionType || '',
                    <div>
                      
                      <span
                        style={{
                          cursor: 'pointer',
                          color: '#4caf50',
                          paddingRight: '5px'
                        }}
                        onClick={() => this.saveTableItem(e)}
                      >
                        <Check />
                      </span>

                      <span
                        style={{
                          color: '#f44336',
                          cursor: 'pointer',
                        }}
                        onClick={(x) => this.deleteTableItem(e)}
                      >
                        <Close />
                      </span>
                      
                      
                    </div>
                  ]}
                )}
              />
            </div>
          </GridItem>
          }
          
					<GridItem sm={11}>
						<div style={{float: 'right'}}>
              <button type='submit' ref={this.button} style={{visibility: 'hidden'}}></button>
							<Button
								color="success"
								type="button"
                style={{position:'absolute', bottom:'10px', right:'40px'}}
                onClick={()=> {
                  this.setState({...this.state, goToNext: true})
                  this.button.current.click()
                }}
							>
								Next
							</Button>
						</div>
					</GridItem>
          
          {this.state.openModal &&
            <SymbolsModal
              close={() => this.setState({...this.state,openModal: false})}
              groups={this.state.symbolTree}
              selected={this.state.selectedSubProfileRule}
              symbolGroups={this.props.symbolGroups}
              save={(id, data) => this.setSymbols(id, data)}
            />
          }

        </GridContainer>
      </form>
  	);
  }
}
const state=(state)=>({
  subProfileRules: state.subProfileRules.list,
  currencies: state.currencies.list,
  symbolGroups: state.symbolGroups.list
})
const dispatch=(dispatch)=>({
  subProfileRuleFetch:(subProfileId, id)=>dispatch(subProfileRuleFetch(subProfileId, id)),
  subProfileRulesFetch:(id)=>dispatch(subProfileRulesFetchHelper(id)),
  subProfileFetch:(id)=>dispatch(subProfileFetch(id)),
  subProfileSave:(data)=>dispatch(subProfileSave(data)),
  subProfileRulesSave:(id, data)=>dispatch(subProfileRulesSave(id, data)),
  subProfileRuleRemove: (subProfileId, id) => dispatch(subProfileRuleRemove(subProfileId, id)),
  danger:(text,sec, position)=>dispatch(danger(text,sec, position)),
  success:(text,sec)=>dispatch(success(text,sec)),
  currenciesFetch: () => dispatch(currenciesFetch()),
  currencyFilter: (filter) => dispatch(currencyFilter(filter)),
  symbolGroupsFetch: () => dispatch(symbolGroupsFetch()),
  symbolGroupFilter: (filter) => dispatch(symbolGroupFilter(filter))
})
export default withStyles({...styles, ...regularFormsStyle, ...customStyle})(connect(state,dispatch)(Cryptos))



// WEBPACK FOOTER //
// ./src/views/Profiles/SubProfileWizard/Cryptos.jsx